import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ResponsiveLegalDocumentDialog from './ResponsiveLegalDocumentDialog';
import LegalSectionsBody from './LegalSectionsBody';
const TERMS_SECTIONS = [
    'section1',
    'section2',
    'section3',
    'section4',
    'section5',
    'section6',
    'section7',
    'section8'
];
const FamilyLegalTermsDialog = ({ open, onClose }) => {
    const { t } = useTranslation();
    const baseKey = 'familyForm.legalTerms';
    return (_jsxs(ResponsiveLegalDocumentDialog, { open: open, onClose: onClose, title: t(`${baseKey}.pageTitle`), children: [_jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 0.5 }, children: _jsx(Typography, { variant: 'subtitle2', fontWeight: 600, color: 'text.primary', children: t(`${baseKey}.subtitle`) }) }), _jsx(LegalSectionsBody, { translationBaseKey: baseKey, sectionKeys: TERMS_SECTIONS })] }));
};
export default FamilyLegalTermsDialog;
